"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[0],{

/***/ 1079:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_ComponentSwitch; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(6042);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(9396);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/outline/esm/index.js + 223 modules
var esm = __webpack_require__(2672);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./lib/classNames.ts
var classNames = __webpack_require__(9413);
// EXTERNAL MODULE: ./components/BlurImage.tsx
var BlurImage = __webpack_require__(1166);
// EXTERNAL MODULE: ./components/RichTextRenderer.tsx
var RichTextRenderer = __webpack_require__(6205);
;// CONCATENATED MODULE: ./components/sections/AlternatingWithTestimonial.tsx








var AlternatingWithTestimonial = function(props) {
    var ref;
    var remaning = props.reverse ? 1 : 0;
    var sections = (ref = props.sections) === null || ref === void 0 ? void 0 : ref.map(function(section) {
        return section.icon ? (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, section), {
            icon: esm[section.icon]
        }) : section;
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "relative pt-16 pb-32 overflow-hidden bg-white",
        children: sections === null || sections === void 0 ? void 0 : sections.map(function(section, sectionIdx) {
            var ref;
            /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
                className: (0,classNames/* default */.Z)(sectionIdx === 0 ? "relative" : "mt-24"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "lg:mx-auto lg:max-w-7xl lg:px-8 lg:grid lg:grid-cols-2 lg:grid-flow-col-dense lg:gap-24",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (0,classNames/* default */.Z)(sectionIdx % 2 === remaning ? "lg:py-16" : "lg:py-32 lg:col-start-2", "max-w-xl px-4 mx-auto sm:px-6 lg:max-w-none lg:mx-0 lg:px-0"),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    children: [
                                        section.icon && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "flex items-center justify-center w-12 h-12 rounded-md bg-primary",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(section.icon, {
                                                    className: "w-6 h-6 text-white",
                                                    "aria-hidden": "true"
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "mt-6",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                    className: "text-3xl font-extrabold tracking-tight text-gray-900",
                                                    children: section.name
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "mt-4 text-xl text-gray-500",
                                                    children: section.description && /*#__PURE__*/ (0,jsx_runtime.jsx)(RichTextRenderer/* default */.Z, {
                                                        content: section.description.raw
                                                    })
                                                }),
                                                section.button && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "mt-6",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                        href: section.buttonLink || "#",
                                                        passHref: true,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            className: "inline-flex px-4 py-2 text-base font-medium text-white border border-transparent rounded-md shadow-sm bg-secondary hover:bg-lime-500",
                                                            children: section.button
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                section.testimonial && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "pt-6 mt-8 border-t border-gray-200",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("blockquote", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "text-base text-gray-500",
                                                    children: section.testimonial.content
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("footer", {
                                                className: "mt-3",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "flex items-center space-x-3",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "relative flex-shrink-0 w-6 h-6",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BlurImage/* default */.Z, {
                                                                className: "absolute rounded-full",
                                                                src: ((ref = section.testimonial.image) === null || ref === void 0 ? void 0 : ref.url) || "/avatar-placeholder.svg",
                                                                width: "32",
                                                                height: "32",
                                                                alt: section.testimonial.name + " avatar"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "text-base font-medium text-gray-700",
                                                            children: [
                                                                section.testimonial.name,
                                                                section.testimonial.position && ", ".concat(section.testimonial.position)
                                                            ]
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (0,classNames/* default */.Z)(sectionIdx % 2 === remaning ? "" : "lg:col-start-1", "mt-12 sm:mt-16 lg:mt-0"),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "pl-4 -mr-48 sm:pl-6 md:-mr-16 lg:px-0 lg:m-0 lg:relative lg:h-full",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BlurImage/* default */.Z, {
                                    className: (0,classNames/* default */.Z)(sectionIdx % 2 === remaning ? "lg:left-0" : "lg:right-0", "object-cover w-full shadow-xl rounded-xl ring-1 ring-black ring-opacity-5 lg:absolute lg:h-full lg:w-auto lg:max-w-none"),
                                    src: section.image.url,
                                    alt: section.imageAlt || "",
                                    width: "1011",
                                    height: "675",
                                    sizes: "(max-width: 768px) 90vw, 50vw"
                                })
                            })
                        })
                    ]
                })
            }, section.id);
        })
    });
};
/* harmony default export */ var sections_AlternatingWithTestimonial = (AlternatingWithTestimonial);

// EXTERNAL MODULE: ./components/sections/Blog3ColumnCard.tsx
var Blog3ColumnCard = __webpack_require__(9773);
;// CONCATENATED MODULE: ./components/sections/CallToAction.tsx


var CallToAction = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "bg-gray-50",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "px-4 py-12 mx-auto max-w-7xl sm:px-6 lg:flex lg:items-center lg:justify-between lg:py-16 lg:px-8",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                    className: "text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "block",
                            children: props.highlightedTitlePrefix
                        }),
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "block text-primary",
                            children: props.title
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex mt-8 lg:mt-0 lg:flex-shrink-0",
                    children: [
                        props.primaryButton && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "inline-flex rounded-md shadow",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: props.primaryButtonLink || "#",
                                passHref: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    className: "inline-flex items-center justify-center px-5 py-3 text-base font-medium text-white border border-transparent rounded-md bg-secondary hover:bg-lime-500",
                                    children: props.primaryButton
                                })
                            })
                        }),
                        props.secondaryButton && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "inline-flex ml-3 rounded-md shadow",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: props.secondaryButtonLink || "#",
                                passHref: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    className: "inline-flex items-center justify-center px-5 py-3 text-base font-medium bg-white border border-transparent rounded-md text-primary hover:bg-indigo-50",
                                    children: props.secondaryButton
                                })
                            })
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var sections_CallToAction = (CallToAction);

;// CONCATENATED MODULE: ./components/sections/Centered2ColumnFeature.tsx





var Centered2ColumnFeature = function(props) {
    var ref;
    var features = (ref = props.features) === null || ref === void 0 ? void 0 : ref.map(function(feature) {
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, feature), {
            icon: esm[feature.icon]
        });
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "py-12 bg-white",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "px-4 mx-auto max-w-7xl sm:px-6 lg:px-8",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "lg:text-center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            className: "text-base font-semibold tracking-wide uppercase text-primary",
                            children: props.superTitle
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "mt-2 text-3xl font-extrabold leading-8 tracking-tight text-gray-900 sm:text-4xl",
                            children: props.title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "max-w-2xl mt-4 text-xl text-gray-500 lg:mx-auto",
                            children: props.description
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "mt-10",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("dl", {
                        className: "space-y-10 md:space-y-0 md:grid md:grid-cols-2 md:gap-x-8 md:gap-y-10",
                        children: features === null || features === void 0 ? void 0 : features.map(function(feature) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: feature.link || "#",
                                passHref: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                    className: "relative",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("dt", {
                                            children: [
                                                feature.icon && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "absolute flex items-center justify-center w-12 h-12 text-white rounded-md bg-primary",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(feature.icon, {
                                                        className: "w-6 h-6",
                                                        "aria-hidden": "true"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "ml-16 text-lg font-medium leading-6 text-gray-900",
                                                    children: feature.name
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("dd", {
                                            className: "mt-2 ml-16 text-base text-gray-500",
                                            children: feature.description
                                        })
                                    ]
                                })
                            }, feature.id);
                        })
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var sections_Centered2ColumnFeature = (Centered2ColumnFeature);

;// CONCATENATED MODULE: ./components/sections/Centered3ColumnFeature.tsx





var Centered3ColumnFeature = function(props) {
    var ref;
    var features = (ref = props.features) === null || ref === void 0 ? void 0 : ref.map(function(feature) {
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, feature), {
            icon: esm[feature.icon]
        });
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "relative py-16 bg-white sm:py-24 lg:py-32",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "max-w-md px-4 mx-auto text-center sm:max-w-3xl sm:px-6 lg:max-w-7xl lg:px-8",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                    className: "text-base font-semibold tracking-wider uppercase text-primary",
                    children: props.superTitle
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "mt-2 text-3xl font-extrabold tracking-tight text-gray-900 sm:text-4xl",
                    children: props.title
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "mx-auto mt-5 text-xl text-gray-500 max-w-prose",
                    children: props.description
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "mt-12",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-3",
                        children: features === null || features === void 0 ? void 0 : features.map(function(feature) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: feature.link || "#",
                                passHref: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    className: "pt-6",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "flow-root px-6 pb-8 rounded-lg bg-gray-50",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "-mt-6",
                                            children: [
                                                feature.icon ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "inline-flex items-center justify-center p-3 rounded-md shadow-lg bg-primary",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(feature.icon, {
                                                            className: "w-6 h-6 text-white",
                                                            "aria-hidden": "true"
                                                        })
                                                    })
                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "pt-3"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                    className: "mt-8 text-lg font-medium tracking-tight text-gray-900",
                                                    children: feature.name
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "mt-5 text-base text-gray-500",
                                                    children: feature.description
                                                })
                                            ]
                                        })
                                    })
                                })
                            }, feature.name);
                        })
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var sections_Centered3ColumnFeature = (Centered3ColumnFeature);

// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/disclosure/disclosure.js + 1 modules
var disclosure = __webpack_require__(8368);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/outline/esm/ChevronDownIcon.js
var ChevronDownIcon = __webpack_require__(1782);
// EXTERNAL MODULE: ./node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(2962);
;// CONCATENATED MODULE: ./components/sections/CenteredAccordion.tsx






var CenteredAccordion = function(props) {
    var ref, ref1;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* FAQPageJsonLd */.Mg, {
                mainEntity: ((ref = props.questions) === null || ref === void 0 ? void 0 : ref.map(function(q) {
                    return {
                        questionName: q.question,
                        acceptedAnswerText: q.answer.text
                    };
                })) || []
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "bg-gray-50",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "px-4 py-12 mx-auto max-w-7xl sm:py-16 sm:px-6 lg:px-8",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "max-w-3xl mx-auto divide-y-2 divide-gray-200",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                className: "text-3xl font-extrabold text-center text-gray-900 sm:text-4xl",
                                children: props.title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("dl", {
                                className: "mt-6 space-y-6 divide-y divide-gray-200",
                                children: (ref1 = props.questions) === null || ref1 === void 0 ? void 0 : ref1.map(function(faq) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(disclosure/* Disclosure */.p, {
                                        as: "div",
                                        className: "pt-6",
                                        children: function(param) {
                                            var open = param.open;
                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("dt", {
                                                        className: "text-lg",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(disclosure/* Disclosure.Button */.p.Button, {
                                                            className: "flex items-start justify-between w-full text-left text-gray-400",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    className: "font-medium text-gray-900",
                                                                    children: faq.question
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    className: "flex items-center ml-6 h-7",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ChevronDownIcon/* default */.Z, {
                                                                        className: (0,classNames/* default */.Z)(open ? "-rotate-180" : "rotate-0", "h-6 w-6 transform"),
                                                                        "aria-hidden": "true"
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(disclosure/* Disclosure.Panel */.p.Panel, {
                                                        as: "dd",
                                                        className: "pr-12 mt-2",
                                                        unmount: false,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: "text-base text-gray-500",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RichTextRenderer/* default */.Z, {
                                                                content: faq.answer.raw
                                                            })
                                                        })
                                                    })
                                                ]
                                            });
                                        }
                                    }, faq.question);
                                })
                            })
                        ]
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var sections_CenteredAccordion = (CenteredAccordion);

;// CONCATENATED MODULE: ./components/sections/OffsetWithSupportingText.tsx



var OffsetWithSupportingText = function(props) {
    var ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "bg-white",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "px-4 py-16 mx-auto max-w-7xl sm:px-6 lg:py-20 lg:px-8",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "lg:grid lg:grid-cols-3 lg:gap-8",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                className: "text-3xl font-extrabold text-gray-900",
                                children: props.title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "mt-4 text-lg text-gray-500",
                                children: props.description
                            }),
                            props.button && /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: props.buttonLink || "#",
                                passHref: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        className: "inline-flex items-center px-4 py-2 mt-6 text-base font-medium text-white border border-transparent rounded-md shadow-sm bg-secondary hover:bg-lime-500",
                                        children: props.button
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mt-12 lg:mt-0 lg:col-span-2",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("dl", {
                            className: "space-y-12",
                            children: (ref = props.questions) === null || ref === void 0 ? void 0 : ref.map(function(item) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("dt", {
                                            className: "text-lg font-medium leading-6 text-gray-900",
                                            children: item.question
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("dd", {
                                            className: "mt-2 text-base text-gray-500",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RichTextRenderer/* default */.Z, {
                                                content: item.answer.raw
                                            })
                                        })
                                    ]
                                }, item.question);
                            })
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var sections_OffsetWithSupportingText = (OffsetWithSupportingText);

;// CONCATENATED MODULE: ./components/sections/OffWhiteGrid.tsx



var OffWhiteGrid = function(param) {
    var superTitle = param.superTitle, title = param.title, testimonials = param.testimonials, buttonText = param.buttonText, buttonLink = param.buttonLink;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "bg-white py-24 sm:py-32",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "mx-auto max-w-7xl px-6 lg:px-8",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "mx-auto max-w-xl text-center",
                    children: [
                        superTitle && /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            className: "text-lg font-semibold leading-8 tracking-tight text-indigo-600",
                            children: "Testimonials"
                        }),
                        title && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "mt-2 text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl",
                            children: "We have worked with thousands of amazing people"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "mx-auto mt-16 flow-root max-w-2xl sm:mt-20 lg:mx-0 lg:max-w-none",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "-mt-8 sm:-mx-4 sm:columns-2 sm:text-[0] lg:columns-3",
                        children: testimonials && testimonials.map(function(testimonial) {
                            var ref;
                            /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
                                className: "pt-8 sm:w-full sm:px-4",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("figure", {
                                    className: "rounded-2xl bg-gray-50 p-8 text-sm leading-6",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("blockquote", {
                                            className: "text-gray-900",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                children: "“".concat(testimonial.content, "”")
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("figcaption", {
                                            className: "mt-6 flex items-center gap-x-4",
                                            children: [
                                                testimonial.image && /*#__PURE__*/ (0,jsx_runtime.jsx)(BlurImage/* default */.Z, {
                                                    className: "h-10 w-10 rounded-full bg-gray-50",
                                                    src: (ref = testimonial.image) === null || ref === void 0 ? void 0 : ref.url,
                                                    alt: "",
                                                    width: 48,
                                                    height: 48
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "font-semibold text-gray-900",
                                                        children: testimonial.name
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }, testimonial.id);
                        })
                    })
                }),
                buttonText && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "mx-auto max-w-xl text-center pt-12",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: buttonLink || "#",
                        passHref: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            className: "inline-flex items-center justify-center px-5 py-3 text-base font-medium text-white border border-transparent rounded-md bg-secondary hover:bg-lime-500",
                            children: buttonText
                        })
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var sections_OffWhiteGrid = (OffWhiteGrid);

// EXTERNAL MODULE: ./components/sections/SimpleCenteredHeader.tsx
var SimpleCenteredHeader = __webpack_require__(7011);
// EXTERNAL MODULE: ./components/sections/SplitBrandContactForm.tsx
var SplitBrandContactForm = __webpack_require__(8725);
// EXTERNAL MODULE: ./public/logo_with_background.png
var logo_with_background = __webpack_require__(222);
;// CONCATENATED MODULE: ./components/sections/SplitHero.tsx




var SplitHero = function(props) {
    var ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "lg:relative",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "w-full pt-16 pb-20 mx-auto text-center max-w-7xl lg:py-48 lg:text-left",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "px-4 lg:w-1/2 sm:px-8 xl:pr-16",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("h1", {
                            className: "text-4xl font-extrabold tracking-tight text-gray-900 sm:text-5xl md:text-6xl lg:text-5xl xl:text-6xl",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "block xl:inline",
                                    children: props.title
                                }),
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "block text-primary xl:inline",
                                    children: props.highlightedTitleSuffix
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "max-w-md mx-auto mt-3 text-lg text-gray-500 sm:text-xl md:mt-5 md:max-w-3xl",
                            children: props.description
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "mt-10 sm:flex sm:justify-center lg:justify-start",
                            children: [
                                props.primaryButton && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "rounded-md shadow",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: props.primaryButtonLink || "#",
                                        passHref: true,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            className: "flex items-center justify-center w-full px-8 py-3 text-base font-medium text-white border border-transparent rounded-md bg-secondary hover:bg-lime-500 md:py-4 md:text-lg md:px-10",
                                            children: props.primaryButton
                                        })
                                    })
                                }),
                                props.secondaryButton && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "mt-3 rounded-md shadow sm:mt-0 sm:ml-3",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: props.secondaryButtonLink || "#",
                                        passHref: true,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            className: "flex items-center justify-center w-full px-8 py-3 text-base font-medium bg-white border border-transparent rounded-md text-primary hover:bg-gray-50 md:py-4 md:text-lg md:px-10",
                                            children: props.secondaryButton
                                        })
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "relative w-full h-64 sm:h-72 md:h-96 lg:absolute lg:inset-y-0 lg:right-0 lg:w-1/2 lg:h-full",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BlurImage/* default */.Z, {
                    className: "absolute object-cover object-left-top w-full h-full",
                    src: ((ref = props.image) === null || ref === void 0 ? void 0 : ref.url) || logo_with_background/* default */.Z,
                    width: "2022",
                    height: "1349",
                    alt: props.imageAlt || props.title || "",
                    priority: true,
                    sizes: "(max-width: 768px) 100vw, 50vw"
                })
            })
        ]
    });
};
/* harmony default export */ var sections_SplitHero = (SplitHero);

;// CONCATENATED MODULE: ./components/sections/Team.tsx




var Team = function(props) {
    var ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "bg-white",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "px-4 py-12 mx-auto max-w-7xl sm:px-6 lg:px-8 lg:py-24",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "space-y-12 lg:grid lg:grid-cols-3 lg:gap-8 lg:space-y-0",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "lg:col-span-3",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                        role: "list",
                        className: "space-y-12 sm:divide-y sm:divide-gray-200 sm:space-y-0 sm:-mt-8 lg:gap-x-8 lg:space-y-0",
                        children: (ref = props.members) === null || ref === void 0 ? void 0 : ref.map(function(person) {
                            var ref;
                            /*#__PURE__*/ return (0,jsx_runtime.jsx)("li", {
                                className: "sm:py-8",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "space-y-4 sm:grid sm:grid-cols-3 sm:items-start sm:gap-6 sm:space-y-0",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "aspect-w-3 aspect-h-4 sm:aspect-w-3 sm:aspect-h-4",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BlurImage/* default */.Z, {
                                                className: "object-cover rounded-lg shadow-lg",
                                                src: ((ref = person.image) === null || ref === void 0 ? void 0 : ref.url) || logo_with_background/* default */.Z,
                                                alt: person.name,
                                                fill: true,
                                                sizes: "(max-width: 768px) 95vw, 33vw"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "sm:col-span-2",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "space-y-4",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "space-y-1 text-lg font-medium leading-6",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                                children: person.name
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                className: "text-indigo-600",
                                                                children: person.speciality.join(" / ")
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "text-lg text-gray-500",
                                                        children: person.resume && /*#__PURE__*/ (0,jsx_runtime.jsx)(RichTextRenderer/* default */.Z, {
                                                            content: person.resume.raw
                                                        })
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                })
                            }, person.name);
                        })
                    })
                })
            })
        })
    });
};
/* harmony default export */ var sections_Team = (Team);

;// CONCATENATED MODULE: ./components/sections/TestimonialsWithOverlappingImage.tsx



var TestimonialsWithOverlappingImage = function(props) {
    var ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: props.testimonials && ((ref = props.testimonials) === null || ref === void 0 ? void 0 : ref.map(function(testimonial, testimonialIdx) {
            var ref;
            /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
                className: "pt-16 bg-white lg:py-24",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "pb-16 bg-primary lg:pb-0 lg:z-10 lg:relative",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "lg:mx-auto lg:max-w-7xl lg:px-8 lg:grid lg:grid-cols-2 lg:gap-8",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (0,classNames/* default */.Z)(testimonialIdx % 2 === 0 ? "" : "order-last", "relative lg:-my-8"),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        "aria-hidden": "true",
                                        className: "absolute inset-x-0 top-0 bg-white h-1/2 lg:hidden"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "max-w-md px-4 mx-auto sm:max-w-3xl sm:px-6 lg:p-0 lg:h-full",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "overflow-hidden shadow-xl bg-secondary aspect-w-10 aspect-h-10 rounded-xl lg:h-full",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BlurImage/* default */.Z, {
                                                className: "object-contain lg:h-full lg:w-full rounded-xl",
                                                src: (testimonial === null || testimonial === void 0 ? void 0 : (ref = testimonial.image) === null || ref === void 0 ? void 0 : ref.url) || "/avatar-placeholder.svg",
                                                alt: testimonial.name + "'s testimonial",
                                                sizes: "(max-width: 768px) 90vw, (max-width: 1200px) 90vw, 33vw",
                                                fill: true
                                            })
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (0,classNames/* default */.Z)(testimonialIdx % 2 === 0 ? "lg:pl-8" : "lg:pr-8", "mt-12 lg:m-0"),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "max-w-md px-4 mx-auto sm:max-w-2xl sm:px-6 lg:px-0 lg:py-20 lg:max-w-none",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("blockquote", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                                        className: "w-12 h-12 text-white opacity-25",
                                                        fill: "currentColor",
                                                        viewBox: "0 0 32 32",
                                                        "aria-hidden": "true",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                            d: "M9.352 4C4.456 7.456 1 13.12 1 19.36c0 5.088 3.072 8.064 6.624 8.064 3.36 0 5.856-2.688 5.856-5.856 0-3.168-2.208-5.472-5.088-5.472-.576 0-1.344.096-1.536.192.48-3.264 3.552-7.104 6.624-9.024L9.352 4zm16.512 0c-4.8 3.456-8.256 9.12-8.256 15.36 0 5.088 3.072 8.064 6.624 8.064 3.264 0 5.856-2.688 5.856-5.856 0-3.168-2.304-5.472-5.184-5.472-.576 0-1.248.096-1.44.192.48-3.264 3.456-7.104 6.528-9.024L25.864 4z"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: "mt-6 text-2xl font-medium text-white",
                                                        children: testimonial.content
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("footer", {
                                                className: "mt-6",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: "text-base font-medium text-white",
                                                        children: testimonial.name
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: "text-base font-medium text-indigo-100",
                                                        children: testimonial.position
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            })
                        ]
                    })
                })
            }, testimonial.id);
        }))
    });
};
/* harmony default export */ var sections_TestimonialsWithOverlappingImage = (TestimonialsWithOverlappingImage);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(9815);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/solid/esm/StarIcon.js
var StarIcon = __webpack_require__(7901);
;// CONCATENATED MODULE: ./components/sections/WithStarRating.tsx




var WithStarRating = function(param) {
    var testimonial = param.testimonial;
    var ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: "bg-white px-6 py-24 sm:py-20 lg:px-8",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("figure", {
            className: "mx-auto max-w-2xl",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                    className: "sr-only",
                    children: [
                        testimonial === null || testimonial === void 0 ? void 0 : testimonial.rating,
                        " out of 5 stars"
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex gap-x-1 text-indigo-600",
                    children: (0,_to_consumable_array/* default */.Z)(Array(5)).map(function(_, i) {
                        /*#__PURE__*/ return (0,jsx_runtime.jsx)(StarIcon/* default */.Z, {
                            className: "h-5 w-5 flex-none ".concat((testimonial === null || testimonial === void 0 ? void 0 : testimonial.rating) && i + 1 <= testimonial.rating ? "text-indigo-500" : "text-gray-400"),
                            "aria-hidden": "true"
                        }, i);
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("blockquote", {
                    className: "mt-10 text-xl font-semibold leading-8 tracking-tight text-gray-900 sm:text-2xl sm:leading-9",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        children: [
                            "“",
                            testimonial === null || testimonial === void 0 ? void 0 : testimonial.content,
                            "”"
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("figcaption", {
                    className: "mt-10 flex items-center gap-x-6",
                    children: [
                        (testimonial === null || testimonial === void 0 ? void 0 : testimonial.image) && /*#__PURE__*/ (0,jsx_runtime.jsx)(BlurImage/* default */.Z, {
                            className: "h-12 w-12 rounded-full bg-gray-50",
                            src: testimonial === null || testimonial === void 0 ? void 0 : (ref = testimonial.image) === null || ref === void 0 ? void 0 : ref.url,
                            alt: "",
                            width: 48,
                            height: 48
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "text-sm leading-6",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "font-semibold text-gray-900",
                                    children: testimonial === null || testimonial === void 0 ? void 0 : testimonial.name
                                }),
                                (testimonial === null || testimonial === void 0 ? void 0 : testimonial.position) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "mt-0.5 text-gray-600",
                                    children: testimonial.position
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var sections_WithStarRating = (WithStarRating);

;// CONCATENATED MODULE: ./components/ComponentSwitch.tsx
















var ComponentSwitch = function(props) {
    var elemetns = props.components.map(function(component) {
        switch(component.__typename){
            case "SimpleCenteredHeader":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(SimpleCenteredHeader/* default */.Z, (0,_object_spread/* default */.Z)({}, component), component.id);
            case "Centered2ColumnFeature":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(sections_Centered2ColumnFeature, (0,_object_spread/* default */.Z)({}, component), component.id);
            case "CenteredAccordion":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(sections_CenteredAccordion, (0,_object_spread/* default */.Z)({}, component), component.id);
            case "CallToAction":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(sections_CallToAction, (0,_object_spread/* default */.Z)({}, component), component.id);
            case "AlternatingWithTestimonial":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(sections_AlternatingWithTestimonial, (0,_object_spread/* default */.Z)({}, component), component.id);
            case "SplitBrandContactForm":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(SplitBrandContactForm/* default */.Z, (0,_object_spread/* default */.Z)({}, component), component.id);
            case "TestimonialsWithOverlappingImage":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(sections_TestimonialsWithOverlappingImage, (0,_object_spread/* default */.Z)({}, component), component.id);
            case "Centered3ColumnFeature":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(sections_Centered3ColumnFeature, (0,_object_spread/* default */.Z)({}, component), component.id);
            case "SplitHero":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(sections_SplitHero, (0,_object_spread/* default */.Z)({}, component), component.id);
            case "OffsetWithSupportingText":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(sections_OffsetWithSupportingText, (0,_object_spread/* default */.Z)({}, component), component.id);
            case "Blog3ColumnCard":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Blog3ColumnCard/* default */.Z, (0,_object_spread/* default */.Z)({}, component), component.id);
            case "Team":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(sections_Team, (0,_object_spread/* default */.Z)({}, component), component.id);
            case "OffWhiteGrid":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(sections_OffWhiteGrid, (0,_object_spread/* default */.Z)({}, component), component.id);
            case "WithStarRating":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(sections_WithStarRating, (0,_object_spread/* default */.Z)({}, component), component.id);
            default:
                return undefined;
        }
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: elemetns
    });
};
/* harmony default export */ var components_ComponentSwitch = (ComponentSwitch);


/***/ }),

/***/ 6000:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2962);
/* harmony import */ var _lib_baseUrl__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9836);
/* harmony import */ var _ComponentSwitch__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1079);
/* harmony import */ var _RichTextRenderer__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6205);





var Page = function(param) {
    var page = param.page;
    var ref, ref1, ref2, ref3;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_1__/* .NextSeo */ .PB, {
                title: page.seo.title || page.title || "",
                description: page.seo.description || page.description || "",
                noindex: page.seo.noIndex,
                openGraph: {
                    title: page.seo.title || page.title || "",
                    description: page.seo.description || page.description || ""
                },
                canonical: page.seo.slug === "home" ? _lib_baseUrl__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z : "".concat(_lib_baseUrl__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, "/").concat(page.seo.slug)
            }),
            page.highlightedTitlePrefix && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "relative py-12 overflow-hidden bg-white",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "relative px-4 sm:px-6 lg:px-8",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "mx-auto text-lg max-w-prose",
                            children: [
                                (page.highlightedTitlePrefix || page.title) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h1", {
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            className: "block text-base font-semibold tracking-wide text-center text-indigo-600 uppercase",
                                            children: page.highlightedTitlePrefix
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            className: "block mt-2 text-3xl font-extrabold leading-8 tracking-tight text-center text-gray-900 sm:text-4xl",
                                            children: page.title
                                        })
                                    ]
                                }),
                                page.description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    className: "mt-8 text-xl leading-8 text-gray-500",
                                    children: page.description
                                })
                            ]
                        }),
                        ((ref = page.content) === null || ref === void 0 ? void 0 : ref.raw) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "mx-auto mt-6 prose prose-lg text-gray-500 prose-green",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_RichTextRenderer__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                content: (ref1 = page.content) === null || ref1 === void 0 ? void 0 : ref1.raw
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "relative overflow-hidden",
                children: page.components && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ComponentSwitch__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                    components: page.components
                })
            }),
            ((ref2 = page.content) === null || ref2 === void 0 ? void 0 : ref2.raw) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "mx-auto mt-6 prose prose-lg text-gray-500 prose-green",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_RichTextRenderer__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                    content: (ref3 = page.content) === null || ref3 === void 0 ? void 0 : ref3.raw
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Page);


/***/ }),

/***/ 7011:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);

var SimpleCenteredHeader = function(param) {
    var superTitle = param.superTitle, title = param.title, description = param.description;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "bg-white",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "px-4 py-16 mx-auto max-w-7xl sm:py-24 sm:px-6 lg:px-8",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "text-center",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                        className: "text-base font-semibold tracking-wide text-indigo-600 uppercase",
                        children: superTitle
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: "mt-1 text-4xl font-extrabold text-gray-900 sm:text-5xl sm:tracking-tight lg:text-6xl",
                        children: title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: "max-w-xl mx-auto mt-5 text-xl text-gray-500",
                        children: description
                    })
                ]
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SimpleCenteredHeader);


/***/ })

}]);